module.exports = __webpack_public_path__ + "static/media/noSignal.c7b6c335.mp3";